/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2026 Valerii Chupurnov. All rights reserved. https://xdsoft.net
 */

// Chinese Traditional (繁體中文)
export default {
	'Type something': '輸入一些內容',
	Advanced: '進階',
	'About Jodit': '關於Jodit',
	'Jodit Editor': 'Jodit Editor',
	"Jodit User's Guide": '開發者指南',
	'contains detailed help for using': '使用幫助',
	'For information about the license, please go to our website:':
		'相關授權條款資訊，請造訪我們的網站：',
	'Buy full version': '購買完整版本',
	'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.':
		'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.',
	Anchor: '錨點',
	'Open in new tab': '在新分頁開啟',
	'Open in fullsize': '全螢幕編輯',
	'Clear Formatting': '清除樣式',
	'Fill color or set the text color': '顏色',
	Redo: '取消復原',
	Undo: '復原',
	Bold: '粗體',
	Italic: '斜體',
	'Insert Unordered List': '項目符號清單',
	'Insert Ordered List': '編號清單',
	'Align Center': '置中',
	'Align Justify': '文字對齊',
	'Align Left': '靠左',
	'Align Right': '靠右',
	'Insert Horizontal Line': '分割線',
	'Insert Image': '圖片',
	'Insert file': '檔案',
	'Insert youtube/vimeo video': '插入 youtube/vimeo 影片',
	'Insert link': '插入連結',
	'Font size': '文字大小',
	'Font family': '字型',
	'Insert format block': '格式化區塊',
	Normal: '內文',
	'Heading 1': '標題1',
	'Heading 2': '標題2',
	'Heading 3': '標題3',
	'Heading 4': '標題4',
	Quote: '引文',
	Code: '程式碼',
	Insert: '插入',
	'Insert table': '表格',
	'Decrease Indent': '減少縮排',
	'Increase Indent': '增加縮排',
	'Select Special Character': '選擇特殊符號',
	'Insert Special Character': '特殊符號',
	'Paint format': '格式複製',
	'Change mode': '檢視原始碼',
	Margins: '邊距',
	top: '上',
	right: '右',
	bottom: '下',
	left: '左',
	Styles: '樣式',
	Classes: 'Classes',
	Align: '對齊方式',
	Right: '靠右',
	Center: '置中',
	Left: '靠左',
	'--Not Set--': '無',
	Src: 'Src',
	Title: 'Title',
	Alternative: '替代',
	Link: 'Link',
	'Open link in new tab': '在新分頁開啟連結',
	Image: '圖片',
	file: '檔案',
	'Image properties': '圖片屬性',
	Cancel: '取消',
	Ok: '確定',
	'Your code is similar to HTML. Keep as HTML?':
		'您的程式碼與 HTML 類似，是否貼上 HTML 格式？',
	'Paste as HTML': '貼上 HTML',
	Keep: '保留原始格式',
	Clean: '清除格式',
	'Insert as Text': '以純文字貼上',
	'Word Paste Detected': '貼上 Word 格式',
	'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?':
		'正在貼上 Word/Excel 文件的內容，是否保留原始格式？',
	'Insert only Text': '僅貼上內文',
	'File Browser': '檔案瀏覽',
	'Error on load list': '清單載入錯誤',
	'Error on load folders': '資料夾載入錯誤',
	'Are you sure?': '您確定嗎？',
	'Enter Directory name': '輸入路徑',
	'Create directory': '創建路徑',
	'type name': 'type name',
	'Drop image': '拖曳圖片至此',
	'Drop file': '拖曳檔案至此',
	'or click': '或點擊',
	'Alternative text': '替代文字',
	Browse: '瀏覽',
	Upload: '上傳',
	Background: '背景色',
	Text: '文字',
	Top: '頂部',
	Middle: '中間',
	Bottom: '底部',
	'Insert column before': '插入左方欄',
	'Insert column after': '插入右方欄',
	'Insert row above': '插入上方列',
	'Insert row below': '插入下方列',
	'Delete table': '刪除表格',
	'Delete row': '刪除整列',
	'Delete column': '刪除整欄',
	'Empty cell': '清除內容',
	'Chars: %d': '字元數: %d',
	'Words: %d': '單字數: %d',
	'Strike through': '刪除線',
	Underline: '底線',
	superscript: '上標',
	subscript: '下標',
	'Cut selection': '剪下',
	'Select all': '全選',
	Break: '斷行',
	'Search for': '尋找',
	'Replace with': '取代為',
	Replace: '取代',
	Paste: '貼上',
	'Choose Content to Paste': '選擇內容並貼上',
	All: '全部',
	source: '原始碼',
	bold: '粗體',
	italic: '斜體',
	brush: '顏色',
	link: '連結',
	undo: '復原',
	redo: '取消復原',
	table: '表格',
	image: '圖片',
	eraser: '橡皮擦',
	paragraph: '段落',
	fontsize: '文字大小',
	video: '影片',
	font: '字型',
	about: '關於',
	print: '列印',
	underline: '底線',
	strikethrough: '刪除線',
	indent: '增加縮排',
	outdent: '減少縮排',
	fullsize: '全螢幕',
	shrink: '縮減',
	hr: '分隔線',
	ul: '項目符號清單',
	ol: '編號清單',
	cut: '剪下',
	selectall: '全選',
	'Open link': '打開連結',
	'Edit link': '編輯連結',
	'No follow': 'No follow',
	Unlink: '取消連結',
	Eye: '查看',
	' URL': 'URL',
	Reset: '重設',
	Save: '儲存',
	'Save as ...': '另存為...',
	Resize: '調整大小',
	Crop: '裁切',
	Width: '寬',
	Height: '高',
	'Keep Aspect Ratio': '維持長寬比',
	Yes: '是',
	No: '否',
	Remove: '移除',
	Select: '選擇',
	'Select %s': '選擇: %s',
	Update: '更新',
	'Vertical align': '垂直對齊',
	Merge: '合併',
	'Add column': '新增欄',
	'Add row': '新增列',
	Border: '邊框',
	'Embed code': '嵌入程式碼',
	Delete: '刪除',
	'Horizontal align': '水平對齊',
	Filter: '篩選',
	'Sort by changed': '修改時間排序',
	'Sort by name': '名稱排序',
	'Sort by size': '大小排序',
	'Add folder': '新增資料夾',
	Split: '分割',
	'Split vertical': '垂直分割',
	'Split horizontal': '水平分割',
	'You can only edit your own images. Download this image on the host?':
		'您只能編輯您自己的圖片。是否下載此圖片?',
	'The image has been successfully uploaded to the host!': '圖片上傳成功',
	palette: '調色盤',
	pencil: '鉛筆',
	'There are no files': '沒有檔案',
	Rename: '重新命名',
	'Enter new name': '輸入新名稱',
	preview: '預覽',
	download: '下載',
	'Paste from clipboard': '從剪貼簿貼上',
	"Your browser doesn't support direct access to the clipboard.":
		'瀏覽器無法存取剪貼簿。',
	'Copy selection': '複製已選取項目',
	copy: '複製',
	'Border radius': '邊框圓角',
	'Show all': '顯示全部',
	Apply: '應用',
	'Please fill out this field': '請輸入此欄位',
	'Please enter a web address': '請輸入網址',
	Default: '預設',
	Circle: '圓圈',
	Dot: '點',
	Quadrate: '方形',
	Find: '尋找',
	'Find Previous': '尋找上一個',
	'Find Next': '尋找下一個',
	'Insert className': '插入 class 名稱',
	'Press Alt for custom resizing': '按住 Alt 以調整自訂大小',
	Edit: '編輯',
	'License: %s': '許可證: %s'
};
